module.exports = __webpack_public_path__ + "img/Ca-T600.f64ff9a7.gif";